<template>
	<div class="bankrecharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.push('/user')"></div>
			<div class="big_tit">{{ data.payment.bank }}</div>
		</div>
		<div class="bank_detail">
			<div class="item">
				<p class="info">
					{{ $t('invest_qrcode.amount') }}
					<span>{{ money }}</span>
					<!-- <span>{{ actualAmount }}</span> -->
				</p>
			</div>
			<div class="item">
				<p class="info">{{ $t('invest_bank.name') }}
					<span>{{ data.payment.username }}</span>
				</p>
				<div class="copy_btn" v-clipboard="() => data.payment.username" v-clipboard:success="copy">
					{{ $t('invest_bank.copy') }}
				</div>
			</div>
			<div class="item">
				<p class="info">{{ $t('invest_bank.account') }}
					<span>{{ data.payment.account }}</span>
				</p>
				<div class="copy_btn" v-clipboard="() => data.payment.account" v-clipboard:success="copy">
					{{ $t('invest_bank.copy') }}
				</div>
			</div>
			<div class="item">
				<p class="info">{{ $t('invest_bank.bank') }}
					<span>{{ data.payment.bank }}</span>
				</p>
				<div class="copy_btn" v-clipboard="() => data.payment.bank" v-clipboard:success="copy">
					{{ $t('invest_bank.copy') }}
				</div>
			</div>
			<!-- <div class="item">
				<p class="info">付款人：<input type="text" v-model.trim="pay_user" placeholder="请输入付款人"></p>
			</div>
			<div class="item">
				<p class="info">附言：<input type="text" v-model.trim="pay_remark" placeholder="请输入充值附言"></p>
			</div> -->
		</div>

		<!-- 上传支付凭证 -->
		<div class="upload_card">
			<div class="upload_title">
				<span class="required">*</span>
				<span>上传支付凭证</span>
			</div>
			<div class="upload_area">
				<van-uploader v-model="fileList" :max-count="1" :max-size="10 * 1024 * 1024" @oversize="onOversize"
					:after-read="afterRead" :before-read="beforeRead" :deletable="true">
					<template #default>
						<div class="upload_content" v-if="fileList.length === 0">
							<van-icon name="photograph" class="upload_icon" />
							<span class="upload_text">点击上传支付凭证</span>
						</div>
					</template>
				</van-uploader>
			</div>
			<div class="upload_tip">请上传支付成功截图作为凭证（支持jpg/png格式，最大10MB）</div>
		</div>

		<div class="submit_btn" @click="submitBtn">{{ $t('utils.submit') }}</div>
	</div>
</template>

<script>
/**
 * 银行卡充值页面组件
 * 展示银行账户信息，支持复制账户信息和上传支付凭证
 * 使用van-uploader上传支付凭证，参考addcountUsdt组件实现
 */
import Vue from "vue";
import { Button, Icon, Uploader, Toast, Dialog } from "vant";
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";
import Clipboard from "v-clipboard";
import axios from "axios";

Vue.use(Button).use(Clipboard).use(Icon).use(Uploader).use(Dialog);

export default {
	name: "invest_bank",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {Object} data - 支付配置数据
	 * @returns {string} pay_user - 付款人
	 * @returns {string} pay_remark - 充值附言
	 * @returns {number|string} money - 充值金额
	 * @returns {string} actualAmount - 实际到账金额显示文本
	 * @returns {boolean} submitLoading - 提交按钮加载状态
	 * @returns {Array} fileList - van-uploader文件列表
	 * @returns {string} voucherUrl - 上传成功后的凭证图片URL
	 */
	data() {
		return {
			data: {},
			pay_user: '',
			pay_remark: '',
			money: 0,
			actualAmount: '',
			submitLoading: false,
			fileList: [],
			voucherUrl: '',
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		this.money = this.$route.query.money ? this.$route.query.money : "";
		this.start();
	},
	methods: {
		/**
		 * 复制成功回调
		 * 显示复制成功提示
		 */
		copy() {
			this.$toast({
				className: "toastName",
				message: this.$t('invest_qrcode.copySucceeded'),
			});
		},
		/**
		 * 获取充值支付配置
		 * 从后端获取支付方式信息和订单ID
		 */
		start() {
			Fetch("/user/recharge_type", {
				money: this.$route.query.money ? this.$route.query.money : "",
				id: this.$route.query.id ? this.$route.query.id : ""
			}).then((r) => {
				this.data = r.data;
				this.changeAmount();
			});
		},
		/**
		 * 提交充值申请
		 * 验证凭证URL并提交，成功后跳转到钱包页面
		 */
		submitBtn() {
			// 防止重复提交
			if (this.submitLoading) return;

			// 验证是否上传了支付凭证
			if (!this.voucherUrl) {
				this.$toast({
					message: '请先上传支付凭证',
					position: 'middle',
					forbidClick: true,
					background: 'rgba(0, 0, 0, 0.7)',
					icon: 'warning-o',
				});
				return;
			}

			this.submitLoading = true;

			// 提交充值申请
			Fetch("/user/recharge_apply", {
				id: this.data.orderId,
				voucher: this.voucherUrl
			}).then((r) => {
				this.submitLoading = false;
				if (r.code == 1) {
					this.$toast({
						background: "#07c160",
						message: this.$t('invest_qrcode.submittedSuccessfully'),
					});
					this.$router.replace("/moneybag");
				} else {
					this.$toast({
						message: r.info || r.message || '提交失败，请重试',
						position: 'bottom',
					});
				}
			}).catch((error) => {
				this.submitLoading = false;
				console.error('提交失败:', error);
				this.$toast({
					message: '网络错误，请重试',
					position: 'bottom',
				});
			});
		},
		/**
		 * 文件大小超限回调
		 * 当上传文件超过10MB时显示提示
		 * @param {Object} file - 文件对象
		 */
		onOversize(file) {
			Dialog.alert({
				message: '图片大小不能超过10MB',
			}).then(() => {});
		},
		/**
		 * 文件上传前验证
		 * 验证文件格式是否为jpg/png
		 * @param {Object} file - 文件对象
		 * @returns {boolean} 是否允许上传
		 */
		beforeRead(file) {
			if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
				this.$toast('仅支持jpg/png格式图片');
				return false;
			}
			return true;
		},
		/**
		 * 文件读取完成后上传
		 * 将文件上传到服务器，获取远程URL
		 * @param {Object} file - 包含file属性的文件对象
		 */
		afterRead(file) {
			// 设置上传状态
			file.status = 'uploading';
			file.message = '上传中...';

			// 创建FormData对象
			let formData = new FormData();
			formData.append('language', this.$i18n.locale || "zh_cn");
			formData.append('file', file.file);
			formData.append('token', localStorage.getItem('token'));

			// 显示加载提示
			Toast.loading({
				forbidClick: true,
				duration: 20000,
				message: '上传中...'
			});

			// 上传到服务器
			axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
				Toast.clear();
				if (r.data.code === 1) {
					// 上传成功，保存远程URL
					file.status = 'done';
					file.message = '';
					this.voucherUrl = r.data.data;
					this.$toast({
						message: '上传成功',
						position: 'bottom',
					});
				} else {
					// 上传失败
					file.status = 'failed';
					file.message = '上传失败';
					this.voucherUrl = '';
					if (r.data.info) {
						this.$toast(r.data.info);
					} else {
						this.$toast('上传失败，请重试');
					}
				}
			}).catch((error) => {
				// 网络错误
				Toast.clear();
				file.status = 'failed';
				file.message = '上传失败';
				this.voucherUrl = '';
				console.error('上传失败:', error);
				this.$toast('网络错误，请重试');
			});
		},
		/**
		 * 计算实际到账金额
		 * 根据汇率计算并格式化显示金额
		 */
		changeAmount() {
			var num = 2;
			if (this.data.payment.type == 1) {
				if (this.data.payment.rate > 10000) {
					num = 8;
				} else if (this.data.payment.rate > 1000) {
					num = 6;
				} else if (this.data.payment.rate > 10) {
					num = 4;
				}
				this.actualAmount = "(≈" + (this.money / this.data.payment.rate).toFixed(num) + this.data.payment.mark + ")";
			} else {
				this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num) + ")";
			}
		}
	},
};
</script>

<style lang="less" scoped>
.bankrecharge_wrap {
	background: #fd1c5f !important;
	width: 100%;
	height: 100%;
	position: fixed;
}

.red_top_bg {
	background: #fd1c5f;
}

.bank_detail {
	width: 96%;
	margin-left: 2%;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
	border-radius: 6px;
	margin-top: 12px;
	padding: 30px 16px;
	font-size: 14px;

	.item {
		height: 52px;
		border-bottom: 1px solid #ececec;
		line-height: 52px;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.info {
			font-weight: bold;
			color: #000;

			span:nth-child(1) {
				font-weight: initial;
			}

			span:nth-child(2) {
				color: #999;
				font-size: 14px;
			}
		}

		.copy_btn {
			color: #3d96ff;
			font-size: 12px;
		}
	}
}

.warming {
	margin-top: 17px;
	padding: 0 14px;

	.tit {
		font-size: 14px;
		color: rgba(0, 0, 0, .8);
		line-height: 20px;
		font-weight: bold;
	}

	.content {
		font-size: 12px;
		color: rgba(0, 0, 0, .6);
		line-height: 17px;
		margin-top: 9px;
	}
}

/* 上传支付凭证卡片 */
.upload_card {
	margin: 20px 15px;
	padding: 20px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.upload_title {
		font-size: 15px;
		color: #333;
		font-weight: 600;
		margin-bottom: 15px;
		display: flex;
		align-items: center;

		.required {
			color: #ff5252;
			margin-right: 4px;
			font-size: 16px;
		}
	}

	.upload_area {
		width: 100%;
		min-height: 150px;
		border: 2px dashed #e0e0e0;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;
		overflow: hidden;

		&:hover {
			border-color: #ff5252;
			background: #fff5f5;
		}

		.upload_content {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 30px;

			.upload_icon {
				font-size: 48px;
				color: #ccc;
				margin-bottom: 12px;
			}

			.upload_text {
				font-size: 14px;
				color: #999;
			}
		}
	}

	.upload_tip {
		font-size: 12px;
		color: #999;
		margin-top: 10px;
		text-align: center;
	}
}

/* van-uploader组件样式覆盖 */
/deep/ .van-uploader {
	width: 100%;

	.van-uploader__wrapper {
		width: 100%;
		justify-content: center;
	}

	.van-uploader__input-wrapper {
		width: 100%;
		min-height: 150px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-uploader__upload {
		width: 100%;
		min-height: 150px;
		margin: 0;
		background: transparent;
		border: none;
	}

	.van-uploader__preview {
		width: 100%;
		margin: 0;

		.van-uploader__preview-image {
			width: 100%;
			max-height: 300px;
			border-radius: 4px;
		}

		.van-uploader__preview-delete {
			width: 28px;
			height: 28px;
			background: rgba(0, 0, 0, 0.5);
			border-radius: 50%;
			top: 8px;
			right: 8px;

			&:hover {
				background: rgba(255, 82, 82, 0.8);
			}

			.van-uploader__preview-delete-icon {
				font-size: 18px;
			}
		}
	}

	.van-uploader__mask {
		border-radius: 4px;
	}
}

/* 提交按钮 */
.submit_btn {
	margin: 20px 15px;
	height: 48px;
	line-height: 48px;
	text-align: center;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	border-radius: 24px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	cursor: pointer;
	transition: all 0.3s ease;

	&:active {
		transform: scale(0.98);
		box-shadow: 0 2px 8px rgba(255, 82, 82, 0.4);
	}
}

/* 自定义Toast样式 */
/deep/ .toast-black-text .van-toast__text {
	color: #000000 !important;
}
</style>
